import { ArrowDownRight } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100vh] grain overflow-hidden"
    >
      {/* Background image with soft beige veil */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1734216736145-7cd4b41e6f77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGJlaWdlJTIwc2lsayUyMHRleHR1cmV8ZW58MHx8fHwxNzc4NDczNjk1fDA&ixlib=rb-4.1.0&q=85"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#FAFAF8]/65 via-[#FAFAF8]/45 to-[#FAFAF8]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-44 pb-24 lg:pt-56 lg:pb-32">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <p className="overline reveal" data-testid="hero-overline">
              Face It Aesthetics · Belmore NSW
            </p>
            <h1
              data-testid="hero-title"
              className="font-serif-luxe reveal mt-6 text-[44px] sm:text-[64px] lg:text-[92px] leading-[0.98] tracking-tight text-[#2C2723]"
              style={{ transitionDelay: "120ms" }}
            >
              Where Expertise
              <br />
              <span className="italic font-light text-[#8C6A53]">meets</span>{" "}
              artistry.
            </h1>
            <p
              className="reveal mt-8 max-w-xl text-[15px] leading-relaxed text-[#5C534B]"
              style={{ transitionDelay: "240ms" }}
            >
              Personalised, results-driven treatments by a fully trained Cosmetic
              Registered Nurse — designed to refresh, restore and reveal your
              most considered self.
            </p>

            <div
              className="reveal mt-10 flex flex-wrap items-center gap-4"
              style={{ transitionDelay: "360ms" }}
            >
              <a
                href="#contact"
                data-testid="hero-cta-primary"
                className="btn-luxe inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#2C2723] text-white text-sm tracking-wide"
              >
                Book a Consultation
                <ArrowDownRight size={16} />
              </a>
              <a
                href="#services"
                data-testid="hero-cta-secondary"
                className="inline-flex items-center gap-2 px-8 py-4 rounded-full border border-[#2C2723]/30 text-[#2C2723] text-sm tracking-wide hover:border-[#2C2723] transition-colors"
              >
                Explore Treatments
              </a>
            </div>
          </div>

          <div className="lg:col-span-4 reveal" style={{ transitionDelay: "480ms" }}>
            <div className="border-l border-[#D9C5B2] pl-6">
              <p className="overline">Practitioner</p>
              <p className="font-serif-luxe text-3xl mt-3 text-[#2C2723]">
                Nurse Dimi
              </p>
              <p className="text-xs tracking-[0.24em] uppercase text-[#8C6A53] mt-1">
                Cosmetic Registered Nurse
              </p>
              <p className="text-sm text-[#5C534B] mt-3 leading-relaxed">
                Three years of clinical experience in aesthetic medicine.
                AHPRA-registered and committed to safe, considered, natural
                results.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-0 right-0 max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-end text-[11px] tracking-[0.28em] uppercase text-[#5C534B]">
        <span className="hidden sm:inline">Scroll · Discover</span>
      </div>
    </section>
  );
}
